import React from "react";
import { Link } from "react-router-dom";

/**
 * Shared premium layout for policy / info pages.
 * Props: title, tagline, updated (string), children.
 */
export default function PolicyLayout({ title, tagline, updated, children }) {
  return (
    <div className="pt-28 pb-24 px-6 lg:px-10 relative z-10">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="overline text-white/50 hover:text-white">← Back to Home</Link>
        <div className="overline text-gold mt-8">{tagline}</div>
        <h1 className="font-display text-4xl lg:text-5xl font-bold tracking-tight mt-2">{title}</h1>
        {updated && (
          <div className="font-mono-space text-xs text-white/50 mt-3">EFFECTIVE · {updated}</div>
        )}
        <div className="mt-10 glass rounded-3xl p-8 lg:p-10 space-y-8 text-white/75 leading-relaxed">
          {children}
        </div>
      </div>
    </div>
  );
}

export function Section({ n, title, children }) {
  return (
    <section>
      <div className="flex items-baseline gap-3">
        <span className="font-mono-space text-gold text-sm">{String(n).padStart(2, "0")}</span>
        <h2 className="font-display text-xl font-bold text-white tracking-tight">{title}</h2>
      </div>
      <div className="mt-3 pl-8 text-[15px]">{children}</div>
    </section>
  );
}

export function Bullets({ items }) {
  return (
    <ul className="list-disc list-outside pl-5 space-y-1.5 marker:text-gold">
      {items.map((x, i) => (
        <li key={i}>{x}</li>
      ))}
    </ul>
  );
}
